import { Checkbox, CircularProgress, FormControlLabel } from '@mui/material';
import { useState } from 'react';

import { StyledButton } from './styles';
import { ResponsibilityLetterModal } from '../ResponsibilityLetterModal';
import { useAcceptResponsibilityLetter } from './hooks';

export function AcceptForm() {
  const [checked, setChecked] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const { handleAcceptResponsibilityLetter, isLoading } =
    useAcceptResponsibilityLetter();

  const toggleModal = () => {
    setOpenModal(prev => !prev);
  };

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
  };

  const handleAccept = async () => {
    const isSuccess = await handleAcceptResponsibilityLetter();
    if (isSuccess) {
      toggleModal();
    }
  };

  return (
    <>
      <FormControlLabel
        control={<Checkbox checked={checked} onChange={handleCheckboxChange} />}
        label="Li e concordo com os termos de responsabilidade desta carta."
      />

      <StyledButton
        variant="contained"
        color="secondary"
        disabled={!checked || isLoading}
        onClick={handleAccept}
        endIcon={isLoading ? <CircularProgress size={16} /> : undefined}
      >
        Aceitar
      </StyledButton>

      <ResponsibilityLetterModal
        openModal={openModal}
        toggleModal={toggleModal}
      />
    </>
  );
}
